import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ParticipantSelector from "../common/ParticipantSelector";
import renderHTML from "lib/render-html";
import { TOOL_BAR_HEIGHT } from "lib/settings";
import { Link } from "react-scroll";
import JsonSchema from "components/common/JsonSchema";
import { useAppDispatch } from "store/hooks";
import { addItem } from "store/reducers/cartSlice";
import useLocation from "components/hooks/useLocation";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2),
    paddingBottom: theme.spacing(1.5),
    "&:not(:last-child)": {
      marginBottom: theme.spacing(2.5),
    },
  },
  printAndEmail: {
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "& svg": {
      fontSize: "inherit",
      marginRight: theme.spacing(0.5),
    },
  },
}));

const ScheduleCard = (props: ScheduleCardPorps) => {
  const classes = useStyles();
  const {
    month,
    timing,
    mode,
    sellingPrice,
    strikOutPrice,
    currencyCode,
    dates,
    serviceLevel,
    fastFilling,
    serviceId,
    scheduleId,
    scheduleDetailId,
    eventSchema,
    startMonth,
    endMonth,
    isSameYear,
  } = props;

  const [numberOfParticipant, setNumberOfParticipant] = useState<number>(1);

  const dispatch = useAppDispatch();
  const { country } = useLocation();

  const handleEnroll = () => {
    dispatch(
      //@ts-ignore
      addItem(country as string, {
        numberOfParticipant,
        scheduleDetailId,
        scheduleId,
        serviceId,
      })
    );
  };

  const multiYearDates = `${startMonth} ${dates[0]} - ${endMonth} ${
    dates[dates.length - 1]
  }`;

  const sameYearDates = `${month} ${dates.join(" - ")}`;

  return (
    <Paper className={classes.root} variant="outlined">
      <Grid container alignItems="center" spacing={2}>
        {/* dates */}
        <Grid item xs={8} sm={6} md={4}>
          <Typography
            color="primary"
            variant="h4"
            component="p"
            style={{ fontWeight: 500 }}
            gutterBottom
          >
            {!isSameYear
              ? renderHTML(multiYearDates)
              : renderHTML(sameYearDates)}
            {/* {month} {renderHTML(dates.join(" - "))} */}
          </Typography>
          <Typography variant="caption" paragraph>
            {timing}
          </Typography>
          <Typography gutterBottom>{mode}</Typography>
          <Typography
            component="label"
            style={{ fontSize: 13, textTransform: "capitalize" }}
            gutterBottom
          >
            {serviceLevel}
          </Typography>

          {/* <Typography
            color="error"
            style={{ cursor: "pointer" }}
            onClick={handleDetailOpen}
          >
            View More Detail
          </Typography> */}
        </Grid>
        {/* Hours */}
        {/* <Grid item xs={4} sm={3} md={2}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="hour"
              name="gour"
              value={hour}
              onChange={handleHourChange}
            >
              <FormControlLabel value="4" control={<Radio />} label="4 Hr" />
              <FormControlLabel value="8" control={<Radio />} label="8 Hr" />
            </RadioGroup>
          </FormControl>
        </Grid> */}
        {/* Participant Sceletor */}
        <Grid item xs={6} sm={3} md={2}>
          <ParticipantSelector onChange={setNumberOfParticipant} />
        </Grid>
        <Grid item xs={6} sm={6} md={4}>
          {/* stric-out */}
          <Box textAlign="center">
            <Typography
              color="error"
              style={{ textDecoration: "line-through" }}
            >
              {strikOutPrice ? currencyCode : ""} {strikOutPrice}
            </Typography>
            <Typography
              color="primary"
              variant="h3"
              component="p"
              style={{ fontWeight: 500 }}
            >
              {currencyCode} {sellingPrice}
            </Typography>
            {/* offer-text */}
            {fastFilling && (
              <Typography style={{ color: "green" }} variant="caption">
                {/* Early bird offer Applied */}
                {fastFilling}
              </Typography>
            )}
          </Box>
        </Grid>

        {/* Entoll Me */}
        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="outlined"
            fullWidth
            size="large"
            color="primary"
            onClick={handleEnroll}
          >
            Enroll Now
          </Button>
          <Box mt={2} />
          <Button
            variant="outlined"
            fullWidth
            size="small"
            color="secondary"
            component={Link}
            to="request-for-training-form-section"
            spy={true}
            offset={-TOOL_BAR_HEIGHT}
            duration={500}
          >
            Enquire Now
          </Button>
        </Grid>
      </Grid>

      {/* Print and email this schedule */}
      {/* <Box display="flex" gridGap={16} mt={2}>
        <Typography
          color="textSecondary"
          gutterBottom
          className={classes.printAndEmail}
        >
          <PrintOutlinedIcon />
          Print this schedule
        </Typography>
        <Typography color="textSecondary" className={classes.printAndEmail}>
          <EmailOutlinedIcon />
          Email this schedule
        </Typography>
      </Box> */}
      <JsonSchema data={eventSchema} />
    </Paper>
  );
};

export default ScheduleCard;
